import MorphTargetController from "../morph-target-controller.js";

class MorphTargetMultiController extends MorphTargetController {
    constructor(controllers) {
        super();
        this._controllers = Object.assign({}, controllers);
    }

    setInfluences(object, influences) {
        for (const key in this._controllers) {
            this._controllers[key].setInfluences(object.objects[key], influences);
        }
    }

    setInfluence(object, index, influence) {
        for (const key in this._controllers) {
            this._controllers[key].setInfluence(object.objects[key], index, influence);
        }
    }

    clearInfluences(object) {
        for (const key in this._controllers) {
            this._controllers[key].clearInfluences(object.objects[key]);
        }
    }
}

export default MorphTargetMultiController;
